import { NOTES_DEMO_CONTENT } from './notesDemoContent'
import { noteAt, withContent } from './notesRailDemoNoteUtils'

/** @type {import('../lib/types.js').NotesRailNoteWire} */
export const notesRailDemoMeetingYou = withContent({
  id: 'n-meeting-you',
  kind: 'meeting',
  authorName: 'You',
  participants: [
    { name: 'Jordan Lee', email: 'jordan.lee@company.com' },
    { name: 'Sam Patel', email: 'sam.patel@company.com' },
    { name: 'Alex Rivera', email: 'alex.rivera@company.com' },
    {
      name: 'External Client',
      email: 'client@acmecorp.com',
      isOrgMember: false,
      hasPlatformAccount: false,
    },
  ],
  title: 'Weekly standup',
  content: NOTES_DEMO_CONTENT.meetingStandup,
  at: noteAt(0, 9, 15),
  meetingStartedAt: noteAt(0, 9, 15),
})
